import { KeyDrop } from "@pdfking/tfunc"

import { is_null } from "./is_null"
import { to_array } from "./to_array"

/**
 * Removes specified keys from object.
 *
 * @param data - Object to filter
 * @param to_drop - Key(s) to remove (string, array, or null)
 * @returns Object without dropped keys
 *
 * @example
 * ```ts
 * import { key_drop } from "@pdfking/rfunc"
 *
 * key_drop({ a: "b", c: "d", e: "f" }, "a") // { c: "d", e: "f" }
 * key_drop({ a: "b", c: "d", e: "f" }, ["a", "c"]) // { e: "f" }
 * key_drop({ a: "b" }, null) // { a: "b" }
 * ```
 */
export const key_drop = (data, to_drop) => {
  if (is_null(to_drop)) return data
  return KeyDrop(data, to_array(to_drop))
}
